import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import TeamCard from './TeamCard';

type Props = {
  teamResults: any[];
  myTeamTitle?: string;
  placingFontColor?: string;
  placingGradientStart?: string;
  placingGradientEnd?: string;
}

const TeamLeaderboard:FC<Props> = ({
  teamResults, myTeamTitle, placingFontColor, placingGradientStart, placingGradientEnd
}) => {
  const { t } = useTranslation();

  if (!teamResults.length) return null;

  return (
    <div>
      <h3 className="text-primary text-xl font-bold mb-2">{t('labels.topTeams')}</h3>
      {teamResults.map((teamResult:any, index:number) => (
        <TeamCard
          key={`team-item-${index}`}
          position={index + 1}
          team={teamResult.team}
          totalScore={teamResult.totalScore}
          players={teamResult.players}
          highlighted={teamResult.team === myTeamTitle}
          placingFontColor={placingFontColor}
          gradientStart={placingGradientStart}
          gradientEnd={placingGradientEnd}
        />
      ))}
    </div>
  )
}

export default TeamLeaderboard;
